import { Controller } from 'stimulus'
import GoogleCart from 'mixins/google_chart'

export default class extends GoogleCart(Controller) {

  connect() {
    this.googleConnect()
  }

  disconnect() {
    if (this.chart) this.chart.clearChart()
  }

  googleConnected() {
    google.charts.load("current", { 'packages': ['corechart', 'bar'] })
    google.charts.setOnLoadCallback(this.drawChart)
  }

  drawChart = () => {
    this.chart = new google.visualization.BarChart(this.element)
    this.chart.draw(this.data, google.charts.Bar.convertOptions(this.options))
  }


  get data() {
    return new google.visualization.DataView(google.visualization.arrayToDataTable(JSON.parse(this.element.dataset.data)))
  }

  get options() {
    return {
      height: 350,
      legend: { position: 'none' },
      chartArea: { left: '25%', top: 0, width: '70%', height: '90%' }
    }
  }

}
